import {InjectionToken} from '@angular/core';
import {EnumLoginViewMode, EnumStudioType, IAppStatic, IUser} from "../interfaces";
import {SocialUser} from "@abacritt/angularx-social-login";

export const DEFAULT_PORT = 443; // 442 | 443
export const DEFAULT_CHAT_RELEASE_PORT = 8443; // 8443 | 8442 debug | old chat
// export const DEFAULT_CHAT_RELEASE_PORT = 443; // 442 | 443 debug | new chats
export const DEFAULT_TEMPLATE_ID = '575579'; // Agriculture template to select
export const DEFAULT_RESELLER_ID = 1;
export const DEFAULT_PROTOCOL = 'https://';
export const DEFAULT_SERVER = 'galaxy.signage.me';
export const DEFAULT_DEV_SERVER = 'dev.signage.me';
export const WEB_SERVER = 'https://secure.digitalsignage.com';
export const CHATS_SERVER = 'https://secure.digitalsignage.com';
// export const CHATS_SERVER = 'https://chats.signage.me'; // next version
export const CANVA_APP_BACKEND_URL = `${WEB_SERVER}/canva`; // https://8852623651d9.ngrok.app/canva
export const HOME_URL = new InjectionToken<string>('/home');
export const LOGIN_URL = new InjectionToken<string>('/login');
export const STYLE_HOST = new InjectionToken<Node>('styleHost');
export const TIME_RANGE_SEPARATOR = new InjectionToken<Node>('timeRangeSeparator');
export const REMOTE_PAD_URL = 'http://galaxy.signage.me/Code/js/mouse.html';
export const REMOTE_TOUCH_URL = 'http://signage.me/demo/remotetouch.html';

// timeline constants
export const MAX_PLAYLIST_TIME = 86400;
export const TIMELINE_SCALE = 50 / 600;
export const TIMELINE_SCALE_LONG = 50 / 60;
export const TIMELINE_GRID_H = 50;
export const TIMELINE_GRID_H2 = 90;
export const TIMELINE_ZOOMS = [1 / 60, 1 / 20, 1 / 10, 1 / 2, 1, 3, 6, 18, 36, 72];
export const TIMELINE_ZOOMS_VALUES = ["0:00:10", "0:00:30", "0:01:00", "0:05:00", "0:10:00", "0:30:00", "1:00:00", "3:00:00", "6:00:00", "12:00:00"];
export const RULER_ZOOMS = [2, 1, 0.75, 0.5, 0.25, 0.1];
export const ADDBLOCK_OFFSET = 10;

export const MS_15 = '1034'; // custom cart product
export const ADZ = '1122'; // custom cart product
export const HOST_DIR = 'signstudio';
export const NONE_VALUE = -1;
export const MAX_GB_STORAGE_FREE = 1;
export const MAX_GB_STORAGE_ENTERPRISE = 100;
export const SUPPORTED_FILE_TYPES = ['jpg', 'jpeg', 'png', 'gif', 'mp4', 'svg', 'mp3'];
export const RESOURCE_VIDEO_TYPES = ['mp4', 'flv', 'm4v'];
export const RESOURCE_IMAGE_TYPES = ['jpg', 'jpeg', 'png', 'gif', 'svg'];
export const PREVIOUSLY_USED_ACCOUNT = '-1';
export const LIMIT_FREE_STORAGE = 1073741824; // 1 GB in total bytes;
export const LIMIT_SUBSCRIBE_STORAGE = 26843545600; // 25GB in total bytes
export const LIMIT_UPLOADS_COUNT = 10;
export const ADMINISTRATOR = 'slevy@mediasignage.com';
export const EQUIP_UPLOAD_USER = 'polupload@ms.com'; // previous user: 'zivudlev@gmail.com'
export const EQUIP_UPLOAD_PASS = 'policelev@';
export const EQUIP_UPLOAD_BUSINESS = '640638'; // previous account 627453
export const EQUIP_ACCESS = 'levpol';
export const EQUIP_ACCESS_KON = 'levkon';
export const SmallPageSizeOptions = [5, 10, 20, 30];
export const LargePageSizeOptions = [10, 25, 50, 75, 100];
export const DRAG_ITEM_SIZE = 100;
export const HEAD_FONT_RATE = 0.1;   // set head font size as 10% of scene width
export const TITLE_FONT_RATE = 0.05;   // set title font size as 5% of scene width
export const DATE_DEFAULT_COLOR = '#ff0000';
export const SCHEDULE_COLORS = ['#99D9EA', '#A349A4', '#FF7F27', '#2BB14C', '#ED1C24', '#3F48CC'];
export const STUDIOS = [{name: 'pro', studio_type: 0}, {name: 'lite', studio_type: 1}, {name: 'sign', studio_type: 2}];
export const SERVERS = [
    {name: 'pluto', source_id: 5},
    {name: 'sun', source_id: 8},
    {name: 'jupiter', source_id: 10},
    {name: 'ida', source_id: 12},
    {name: 'earth', source_id: 6},
    {name: 'moon', source_id: 7},
    {name: 'eris', source_id: 9},
    {name: 'neptune', source_id: 13}
];

/** polling of timers **/
export const DEFAULT_SERVER_STATS_POLL = 450000;
export const DEFAULT_LIVE_CHAT_POLL = 300000;
export const DEFAULT_LIVE_CHAT_POLL_V2 = 10000;
export const DEFAULT_STATIONS_POLL = 25000;
export const DEFAULT_STATIONS_SOCKET_POLL = 10000;
export const DEFAULT_STATIONS_ENTERPRISE_POLL = 60000;
export const DEFAULT_SHOW_SALE_AD = 60000;
export const DEFAULT_GEOMAP_POLL = 25000;
export const DEFAULT_FASTERQ_POLL = 25000;
export const DEFAULT_SERVER_PING_POLL = 5000;
export const DEFAULT_NETWORK_STATUS = 65000;
export const DEFAULT_SERVER_STATUS = 65000;
export const DEFAULT_LOAD_NET_DATA_INIT = 1000;
export const DEFAULT_LOAD_NET_DATA = 2000;

export const SKIP_MIMES = [
    'Twitter',
    'TumblrTexts',
    'TumblrPhotos',
    'TumblrVideos',
    'TumblrPosts',
    'YelpReviews',
    'YelpInfo',
    'FiveHundredCollection',
    'FiveHundredUser',
    'EtsyProfile',
    'EtsyShop',
    'EtsyListing',
    'FacebookVideo',
    'FacebookAlbum',
    'FacebookWall',
    'PinterestBoard',
    'PinterestUser',
    'Touch'
];

const {localStoreConfigVersion: localStoreConfigVersion} = require('../../../package.json');

export const TOAST_FASTER: any = {
    'closeButton': 10,
    'timeOut': 500
};

export const locals = ['en', 'af', 'ga', 'sq', 'it', 'ar', 'ja', 'az', 'kn', 'eu', 'ko', 'bn', 'la', 'be', 'lv', 'bg', 'lt', 'ca', 'mk', 'zh-CN', 'ms', 'zh-TW', 'mt', 'hr', 'no', 'cs', 'fa', 'da', 'pl', 'nl', 'pt', 'ro', 'eo', 'ru', 'et', 'sr', 'tl', 'sk', 'fi', 'sl', 'fr', 'es', 'gl', 'sw', 'ka', 'sv', 'de', 'el', 'te', 'ht', 'tr', 'he', 'uk', 'hi', 'ur', 'hu', 'vi', 'is', 'cy', 'id', 'yi'];

export const ORDER_STATUS = [
    {name: 'IN_CART', value: -2},
    {name: 'WAIT_PAYMENT', value: -1},
    {name: 'NEW_ORDER', value: 0},
    {name: 'APPROVED', value: 1},
    {name: 'PROCESSING', value: 2},
    {name: 'ON_HOLD', value: 3},
    {name: 'QUOTE', value: 4},
    {name: 'COMPLETED', value: 5},
    {name: 'OPEN_BALANCE', value: 6}
];

export const appData: IAppStatic = {
    appName: 'SignStudio',
    protocol: DEFAULT_PROTOCOL,
    masterServer: DEFAULT_SERVER,
    loginState: EnumLoginViewMode.INIT,
    workOffline: false, // load scene from / data directory
    isFullFeatures: false, // if is true it we are in dev mode so will show everything, else release mode show only limited features
    privateServer: false,   // mediaSERVERs and Hybrid servers
    globalService: `${WEB_SERVER}:${DEFAULT_PORT}`,
    chatService: `${CHATS_SERVER}:${DEFAULT_CHAT_RELEASE_PORT}/digitalsignage`,
    konenootService: `${CHATS_SERVER}:${DEFAULT_CHAT_RELEASE_PORT}/konenoot`,
    liveChatUrl: 'https://www.digitalsignage.com/support/upload/visitor/index.php?/LiveChat/Chat/Request/_sessionID=8iHoTzrcTQL4KXnf40b47a2305c16ec954270ba7bc31c00c1df4e32xdooTAy9qVXo6zTr1SujXbF6at4/_proactive=0/_filterDepartmentID=/_randomNumber=47/_fullName=/_email=/_promptType=chat',
    liveChatUrlV2: `${DEFAULT_PROTOCOL}${DEFAULT_SERVER}/signstudio/shopping-cart/chat`,
    studioLiteLegacy: 'https://secure.digitalsignage.com/studioweb/UserLogin',
    homePage: 'https://www.digitalsignage.com',
    studio_web: 'https://galaxy.signage.me/signstudio/login',
    studio_exe: 'https://galaxy.signage.me/code/install/exe/CloudSignageStudioSetup.exe',
    studio_dmg: 'https://www.digitalsignage.com/downloads/StudioProMacSigned.pkg',
    studio_air: 'https://galaxy.signage.me/Code/Install/air/CloudSignageStudio.air',
    mediadroid: 'https://digitalsignage.com/_html/mediaplayer.html',
    player_exe: 'https://galaxy.signage.me/Code/install/exe/CloudSignagePlayerSetup.exe',
    player_sign_chrome: 'https://galaxy.signage.me/installplayer/',
    player_sign_chrome_page: 'https://digitalsignage.com/_html/chrome_os.html',
    player_apk: 'https://galaxy.signage.me/Code/Install/apk/6.3/CloudSignagePlayer.apk',
    player_legacy_apk: 'https://galaxy.signage.me/Code/Install/apk/6.3/CloudSignagePlayer.apk',
    player_android_watchdog_v1: 'https://www.digitalsignage.com/downloads/app-v1-release_adz_watchdog.apk',
    player_android_watchdog_v2: 'https://www.digitalsignage.com/downloads/app-v2-release_adz_watchdog.apk',
    player_android_sign_watchdog_2024: 'https://galaxy.signage.me/deploy/signWatchdog.apk',
    player_android_sign_watchdog: 'https://galaxy.signage.me/deploy/android/signService.apk',
    player_android_sign_devices: 'https://galaxy.signage.me/deploy/SignPlayerInstaller.apk',
    google_play: 'https://play.google.com/store/apps/details?id=com.android.chrome',
    player_windows_sign_watchdog_2024: 'https://galaxy.signage.me/deploy/signWatchdogSetup.exe',
    player_windows_sign_watchdog: 'https://galaxy.signage.me/deploy/win-x64/SignServiceSetup.exe',
    player_linux_sign_watchdog: 'https://galaxy.signage.me/deploy/linux_setup.tar.gz',
    player_linux_sign_watchdog_2025: 'coming soon...',
    player_air: 'https://galaxy.signage.me/Code/Install/air/CloudSignagePlayer.air',
    air_link: 'https://airsdk.harman.com/runtime/',
    player_air_exe: 'https://airsdk.harman.com/assets/downloads/AdobeAIR.exe',
    player_air_dmg: 'https://airsdk.harman.com/assets/downloads/AdobeAIR.dmg',
    player_ipa: 'http://ios.digitalsignage.com',
    player_linux: 'https://galaxy.signage.me/Code/mediaServerSignagePlayer.air',
    productImages: './assets/cart/',
    sampleEventFile: 'https://oregon-signage-resources.s3.amazonaws.com/business1000/resources/scenes_snaps/event_import.json',
    cloudSnapshots: 'https://s3-us-west-2.amazonaws.com/oregon-tmtmp1',
    cloudResourcesS3: 'https://s3-us-west-2.amazonaws.com/oregon-signage-resources', /**  no cloud front: to be used with standard resources png / svg / mp4 **/
    cloudResourcesGPU: 'https://oregon-signage-resources.s3-us-west-2.amazonaws.com', /** to be used with GPU / Canvas **/
    localhost: 'http://localhost:4200',
    apiOfflineUrl: 'http://localhost:4200/assets/',
    appBaseUrlsAdnet: 'https://adnet.signage.me',
    googleMapUrl: 'https://maps.googleapis.com/maps/api/js?key=AIzaSyAGD7EQugVG8Gq8X3vpyvkZCnW4E4HONLI&libraries=places',
    googleMapId: 'ID37b321f404e7353c',
    amazonOffer: 'https://www.amazon.com/mediaDROID-X-Pro-Powered-Signage-DigitalSignage-com/dp/B076X6H2KR'
    // player_apk_store: 'https://play.google.com/store/apps/details?id=air.me.signage.player',
    // player_windows_sign_watchdog: 'https://galaxy.signage.me/deploy/win_setup.zip',
    // player_android_sign_watchdog: 'https://galaxy.signage.me/deploy/android_setup.apk', // old
    // cloudResourcesS3: 'https://d1v4etxhugqk9r.cloudfront.net', /** with cloud front: to be used with standard resources png / svg / mp4 **/
    // cloudResourcesGPU: 'https://d1v4etxhugqk9r.cloudfront.net', /** to be used with GPU / Canvas **/
};

export const userTemplate: IUser = {
    loginStatus: null,
    businessId: '',
    ip: '',
    businessName: 'DigitalSignage',
    payerId: -1,
    accountVersion: 'FREE',
    customStudio: null,
    businessDomain: '',
    username: '',
    pricingMethod: null,
    avatar: 'logo.png',
    avatarURL: './assets/s_logo.png',
    email: '',
    passwordNew: '',
    rememberMe: true,
    enterprise: false,
    dashboard: false,
    plus: false,
    status: 0,
    statusLabel: 'Enabled',
    description: '',
    isEnabled: true,
    createdAt: 0,
    webToken: null,
    updatedAt: 0,
    accessToken: '',
    cardNumber: '',
    cardType: '',
    name: '',
    studioType: EnumStudioType.SIGN_STUDIO,
    resellerId: '',
    applicationId: '',
    mediaCloud: 'CLOUD',
    privilegeId: '306738',
    accessMask: '149',
    groupsPrivileges: null,
    accountStatus: null,
    accountStatusReseller: null,
    archiveState: null,
    sourceId: null,
    fromTemplateId: null,
    maxMonitors: null,
    maxDataStorage: null,
    allowSharing: null,
    localStoreConfigVersion
};

export const sampleGoogleUser: SocialUser = {
    "idToken": "XXXXXX",
    "id": "104745605896742239282",
    "name": "Rey Tan",
    "email": "trashy46@gmail.com",
    "photoUrl": "https://lh3.googleusercontent.com/a/AItbvmlLC-lX9Y2ZMEq9cBxWJ4boCqP0aeLod35dPcIs=s96-c",
    "firstName": "Rey",
    "lastName": "Tan",
    "provider": "GOOGLE",
    authorizationCode: null,
    response: null,
    authToken: null
};

export const usaStates = [
    {value: '', name: ''},
    {value: 'AK', name: 'Alaska'},
    {value: 'TX', name: 'Texas'},
    {value: 'AL', name: 'Alabama'},
    {value: 'AR', name: 'Arkansas'},
    {value: 'AZ', name: 'Arizona'},
    {value: 'CA', name: 'California'},
    {value: 'CO', name: 'Colorado'},
    {value: 'CT', name: 'Connecticut'},
    {value: 'DC', name: 'District of Columbia'},
    {value: 'DE', name: 'Delaware'},
    {value: 'FL', name: 'Florida'},
    {value: 'GA', name: 'Georgia'},
    {value: 'HI', name: 'Hawaii'},
    {value: 'IA', name: 'Iowa'},
    {value: 'ID', name: 'Idaho'},
    {value: 'IL', name: 'Illinois'},
    {value: 'IN', name: 'Indiana'},
    {value: 'KS', name: 'Kansas'},
    {value: 'KY', name: 'Kentucky'},
    {value: 'LA', name: 'Louisiana'},
    {value: 'MA', name: 'Massachusetts'},
    {value: 'MD', name: 'Maryland'},
    {value: 'ME', name: 'Maine'},
    {value: 'MI', name: 'Michigan'},
    {value: 'MN', name: 'Minnesota'},
    {value: 'MO', name: 'Missouri'},
    {value: 'MS', name: 'Mississippi'},
    {value: 'MT', name: 'Montana'},
    {value: 'NC', name: 'North Carolina'},
    {value: 'ND', name: 'North Dakota'},
    {value: 'NE', name: 'Nebraska'},
    {value: 'NH', name: 'New Hampshire'},
    {value: 'NJ', name: 'New Jersey'},
    {value: 'NM', name: 'New Mexico'},
    {value: 'NV', name: 'Nevada'},
    {value: 'NY', name: 'New York'},
    {value: 'OH', name: 'Ohio'},
    {value: 'OK', name: 'Oklahoma'},
    {value: 'OR', name: 'Oregon'},
    {value: 'PA', name: 'Pennsylvania'},
    {value: 'RI', name: 'Rhode Island'},
    {value: 'SC', name: 'South Carolina'},
    {value: 'SD', name: 'South Dakota'},
    {value: 'TN', name: 'Tennessee'},
    {value: 'TX', name: 'Texas'},
    {value: 'UT', name: 'Utah'},
    {value: 'VA', name: 'Virginia'},
    {value: 'VT', name: 'Vermont'},
    {value: 'WA', name: 'Washington'},
    {value: 'WI', name: 'Wisconsin'},
    {value: 'WV', name: 'WestVirginia'},
    {value: 'WY', name: 'Wyoming'}
];

export const countries = [
    {"name": "United States", "value": "US"},
    {"name": "Afghanistan", "value": "AF"},
    {"name": "Åland Islands", "value": "AX"},
    {"name": "Albania", "value": "AL"},
    {"name": "Algeria", "value": "DZ"},
    {"name": "American Samoa", "value": "AS"},
    {"name": "Andorra", "value": "AD"},
    {"name": "Angola", "value": "AO"},
    {"name": "Anguilla", "value": "AI"},
    {"name": "Antarctica", "value": "AQ"},
    {"name": "Antigua and Barbuda", "value": "AG"},
    {"name": "Argentina", "value": "AR"},
    {"name": "Armenia", "value": "AM"},
    {"name": "Aruba", "value": "AW"},
    {"name": "Australia", "value": "AU"},
    {"name": "Austria", "value": "AT"},
    {"name": "Azerbaijan", "value": "AZ"},
    {"name": "Bahamas", "value": "BS"},
    {"name": "Bahrain", "value": "BH"},
    {"name": "Bangladesh", "value": "BD"},
    {"name": "Barbados", "value": "BB"},
    {"name": "Belarus", "value": "BY"},
    {"name": "Belgium", "value": "BE"},
    {"name": "Belize", "value": "BZ"},
    {"name": "Benin", "value": "BJ"},
    {"name": "Bermuda", "value": "BM"},
    {"name": "Bhutan", "value": "BT"},
    {"name": "Bolivia", "value": "BO"},
    {"name": "Bosnia and Herzegovina", "value": "BA"},
    {"name": "Botswana", "value": "BW"},
    {"name": "Bouvet Island", "value": "BV"},
    {"name": "Brazil", "value": "BR"},
    {"name": "British Indian Ocean Territory", "value": "IO"},
    {"name": "Brunei Darussalam", "value": "BN"},
    {"name": "Bulgaria", "value": "BG"},
    {"name": "Burkina Faso", "value": "BF"},
    {"name": "Burundi", "value": "BI"},
    {"name": "Cambodia", "value": "KH"},
    {"name": "Cameroon", "value": "CM"},
    {"name": "Canada", "value": "CA"},
    {"name": "Cape Verde", "value": "CV"},
    {"name": "Cayman Islands", "value": "KY"},
    {"name": "Central African Republic", "value": "CF"},
    {"name": "Chad", "value": "TD"},
    {"name": "Chile", "value": "CL"},
    {"name": "China", "value": "CN"},
    {"name": "Christmas Island", "value": "CX"},
    {"name": "Cocos (Keeling) Islands", "value": "CC"},
    {"name": "Colombia", "value": "CO"},
    {"name": "Comoros", "value": "KM"},
    {"name": "Congo", "value": "CG"},
    {"name": "Congo, The Democratic Republic of the", "value": "CD"},
    {"name": "Cook Islands", "value": "CK"},
    {"name": "Costa Rica", "value": "CR"},
    {"name": "Cote D'Ivoire", "value": "CI"},
    {"name": "Croatia", "value": "HR"},
    {"name": "Cuba", "value": "CU"},
    {"name": "Cyprus", "value": "CY"},
    {"name": "Czech Republic", "value": "CZ"},
    {"name": "Denmark", "value": "DK"},
    {"name": "Djibouti", "value": "DJ"},
    {"name": "Dominica", "value": "DM"},
    {"name": "Dominican Republic", "value": "DO"},
    {"name": "Ecuador", "value": "EC"},
    {"name": "Egypt", "value": "EG"},
    {"name": "El Salvador", "value": "SV"},
    {"name": "Equatorial Guinea", "value": "GQ"},
    {"name": "Eritrea", "value": "ER"},
    {"name": "Estonia", "value": "EE"},
    {"name": "Ethiopia", "value": "ET"},
    {"name": "Falkland Islands (Malvinas)", "value": "FK"},
    {"name": "Faroe Islands", "value": "FO"},
    {"name": "Fiji", "value": "FJ"},
    {"name": "Finland", "value": "FI"},
    {"name": "France", "value": "FR"},
    {"name": "French Guiana", "value": "GF"},
    {"name": "French Polynesia", "value": "PF"},
    {"name": "French Southern Territories", "value": "TF"},
    {"name": "Gabon", "value": "GA"},
    {"name": "Gambia", "value": "GM"},
    {"name": "Georgia", "value": "GE"},
    {"name": "Germany", "value": "DE"},
    {"name": "Ghana", "value": "GH"},
    {"name": "Gibraltar", "value": "GI"},
    {"name": "Greece", "value": "GR"},
    {"name": "Greenland", "value": "GL"},
    {"name": "Grenada", "value": "GD"},
    {"name": "Guadeloupe", "value": "GP"},
    {"name": "Guam", "value": "GU"},
    {"name": "Guatemala", "value": "GT"},
    {"name": "Guernsey", "value": "GG"},
    {"name": "Guinea", "value": "GN"},
    {"name": "Guinea-Bissau", "value": "GW"},
    {"name": "Guyana", "value": "GY"},
    {"name": "Haiti", "value": "HT"},
    {"name": "Heard Island and Mcdonald Islands", "value": "HM"},
    {"name": "Holy See (Vatican City State)", "value": "VA"},
    {"name": "Honduras", "value": "HN"},
    {"name": "Hong Kong", "value": "HK"},
    {"name": "Hungary", "value": "HU"},
    {"name": "Iceland", "value": "IS"},
    {"name": "India", "value": "IN"},
    {"name": "Indonesia", "value": "ID"},
    {"name": "Iran, Islamic Republic Of", "value": "IR"},
    {"name": "Iraq", "value": "IQ"},
    {"name": "Ireland", "value": "IE"},
    {"name": "Isle of Man", "value": "IM"},
    {"name": "Israel", "value": "IL"},
    {"name": "Italy", "value": "IT"},
    {"name": "Jamaica", "value": "JM"},
    {"name": "Japan", "value": "JP"},
    {"name": "Jersey", "value": "JE"},
    {"name": "Jordan", "value": "JO"},
    {"name": "Kazakhstan", "value": "KZ"},
    {"name": "Kenya", "value": "KE"},
    {"name": "Kiribati", "value": "KI"},
    {"name": "Korea, Democratic People'S Republic of", "value": "KP"},
    {"name": "Korea, Republic of", "value": "KR"},
    {"name": "Kuwait", "value": "KW"},
    {"name": "Kyrgyzstan", "value": "KG"},
    {"name": "Lao People'S Democratic Republic", "value": "LA"},
    {"name": "Latvia", "value": "LV"},
    {"name": "Lebanon", "value": "LB"},
    {"name": "Lesotho", "value": "LS"},
    {"name": "Liberia", "value": "LR"},
    {"name": "Libyan Arab Jamahiriya", "value": "LY"},
    {"name": "Liechtenstein", "value": "LI"},
    {"name": "Lithuania", "value": "LT"},
    {"name": "Luxembourg", "value": "LU"},
    {"name": "Macao", "value": "MO"},
    {"name": "Macedonia, The Former Yugoslav Republic of", "value": "MK"},
    {"name": "Madagascar", "value": "MG"},
    {"name": "Malawi", "value": "MW"},
    {"name": "Malaysia", "value": "MY"},
    {"name": "Maldives", "value": "MV"},
    {"name": "Mali", "value": "ML"},
    {"name": "Malta", "value": "MT"},
    {"name": "Marshall Islands", "value": "MH"},
    {"name": "Martinique", "value": "MQ"},
    {"name": "Mauritania", "value": "MR"},
    {"name": "Mauritius", "value": "MU"},
    {"name": "Mayotte", "value": "YT"},
    {"name": "Mexico", "value": "MX"},
    {"name": "Micronesia, Federated States of", "value": "FM"},
    {"name": "Moldova, Republic of", "value": "MD"},
    {"name": "Monaco", "value": "MC"},
    {"name": "Mongolia", "value": "MN"},
    {"name": "Montserrat", "value": "MS"},
    {"name": "Morocco", "value": "MA"},
    {"name": "Mozambique", "value": "MZ"},
    {"name": "Myanmar", "value": "MM"},
    {"name": "Namibia", "value": "NA"},
    {"name": "Nauru", "value": "NR"},
    {"name": "Nepal", "value": "NP"},
    {"name": "Netherlands", "value": "NL"},
    {"name": "Netherlands Antilles", "value": "AN"},
    {"name": "New Caledonia", "value": "NC"},
    {"name": "New Zealand", "value": "NZ"},
    {"name": "Nicaragua", "value": "NI"},
    {"name": "Niger", "value": "NE"},
    {"name": "Nigeria", "value": "NG"},
    {"name": "Niue", "value": "NU"},
    {"name": "Norfolk Island", "value": "NF"},
    {"name": "Northern Mariana Islands", "value": "MP"},
    {"name": "Norway", "value": "NO"},
    {"name": "Oman", "value": "OM"},
    {"name": "Pakistan", "value": "PK"},
    {"name": "Palau", "value": "PW"},
    {"name": "Palestinian Territory, Occupied", "value": "PS"},
    {"name": "Panama", "value": "PA"},
    {"name": "Papua New Guinea", "value": "PG"},
    {"name": "Paraguay", "value": "PY"},
    {"name": "Peru", "value": "PE"},
    {"name": "Philippines", "value": "PH"},
    {"name": "Pitcairn", "value": "PN"},
    {"name": "Poland", "value": "PL"},
    {"name": "Portugal", "value": "PT"},
    {"name": "Puerto Rico", "value": "PR"},
    {"name": "Qatar", "value": "QA"},
    {"name": "Reunion", "value": "RE"},
    {"name": "Romania", "value": "RO"},
    {"name": "Russian Federation", "value": "RU"},
    {"name": "RWANDA", "value": "RW"},
    {"name": "Saint Helena", "value": "SH"},
    {"name": "Saint Kitts and Nevis", "value": "KN"},
    {"name": "Saint Lucia", "value": "LC"},
    {"name": "Saint Pierre and Miquelon", "value": "PM"},
    {"name": "Saint Vincent and the Grenadines", "value": "VC"},
    {"name": "Samoa", "value": "WS"},
    {"name": "San Marino", "value": "SM"},
    {"name": "Sao Tome and Principe", "value": "ST"},
    {"name": "Saudi Arabia", "value": "SA"},
    {"name": "Senegal", "value": "SN"},
    {"name": "Serbia and Montenegro", "value": "CS"},
    {"name": "Seychelles", "value": "SC"},
    {"name": "Sierra Leone", "value": "SL"},
    {"name": "Singapore", "value": "SG"},
    {"name": "Slovakia", "value": "SK"},
    {"name": "Slovenia", "value": "SI"},
    {"name": "Solomon Islands", "value": "SB"},
    {"name": "Somalia", "value": "SO"},
    {"name": "South Africa", "value": "ZA"},
    {"name": "South Georgia and the South Sandwich Islands", "value": "GS"},
    {"name": "Spain", "value": "ES"},
    {"name": "Sri Lanka", "value": "LK"},
    {"name": "Sudan", "value": "SD"},
    {"name": "Suriname", "value": "SR"},
    {"name": "Svalbard and Jan Mayen", "value": "SJ"},
    {"name": "Swaziland", "value": "SZ"},
    {"name": "Sweden", "value": "SE"},
    {"name": "Switzerland", "value": "CH"},
    {"name": "Syrian Arab Republic", "value": "SY"},
    {"name": "Taiwan, Province of China", "value": "TW"},
    {"name": "Tajikistan", "value": "TJ"},
    {"name": "Tanzania, United Republic of", "value": "TZ"},
    {"name": "Thailand", "value": "TH"},
    {"name": "Timor-Leste", "value": "TL"},
    {"name": "Togo", "value": "TG"},
    {"name": "Tokelau", "value": "TK"},
    {"name": "Tonga", "value": "TO"},
    {"name": "Trinidad and Tobago", "value": "TT"},
    {"name": "Tunisia", "value": "TN"},
    {"name": "Turkey", "value": "TR"},
    {"name": "Turkmenistan", "value": "TM"},
    {"name": "Turks and Caicos Islands", "value": "TC"},
    {"name": "Tuvalu", "value": "TV"},
    {"name": "Uganda", "value": "UG"},
    {"name": "Ukraine", "value": "UA"},
    {"name": "United Arab Emirates", "value": "AE"},
    {"name": "United Kingdom", "value": "GB"},
    {"name": "United States", "value": "US"},
    {"name": "United States Minor Outlying Islands", "value": "UM"},
    {"name": "Uruguay", "value": "UY"},
    {"name": "Uzbekistan", "value": "UZ"},
    {"name": "Vanuatu", "value": "VU"},
    {"name": "Venezuela", "value": "VE"},
    {"name": "Viet Nam", "value": "VN"},
    {"name": "Virgin Islands, British", "value": "VG"},
    {"name": "Virgin Islands, U.S.", "value": "VI"},
    {"name": "Wallis and Futuna", "value": "WF"},
    {"name": "Western Sahara", "value": "EH"},
    {"name": "Yemen", "value": "YE"},
    {"name": "Zambia", "value": "ZM"},
    {"name": "Zimbabwe", "value": "ZW"}
];


export const states = [
    {name: 'INT', value: 'International'},
    {name: 'AL', value: 'Alabama'},
    {name: 'AK', value: 'Alaska'},
    {name: 'AZ', value: 'Arizona'},
    {name: 'AR', value: 'Arkansas'},
    {name: 'CA', value: 'California'},
    {name: 'CO', value: 'Colorado'},
    {name: 'CT', value: 'Connecticut'},
    {name: 'DE', value: 'Delaware'},
    {name: 'DC', value: 'District of Columbia'},
    {name: 'FL', value: 'Florida'},
    {name: 'GA', value: 'Georgia'},
    {name: 'GU', value: 'Guam'},
    {name: 'HI', value: 'Hawaii'},
    {name: 'ID', value: 'Idaho'},
    {name: 'IL', value: 'Illinois'},
    {name: 'IN', value: 'Indiana'},
    {name: 'IA', value: 'Iowa'},
    {name: 'KS', value: 'Kansas'},
    {name: 'KY', value: 'Kentucky'},
    {name: 'LA', value: 'Louisiana'},
    {name: 'ME', value: 'Maine'},
    {name: 'MD', value: 'Maryland'},
    {name: 'MA', value: 'Massachusetts'},
    {name: 'MI', value: 'Michigan'},
    {name: 'MN', value: 'Minnesota'},
    {name: 'MS', value: 'Mississippi'},
    {name: 'MO', value: 'Missouri'},
    {name: 'MT', value: 'Montana'},
    {name: 'NE', value: 'Nebraska'},
    {name: 'NV', value: 'Nevada'},
    {name: 'NH', value: 'New Hampshire'},
    {name: 'NJ', value: 'New Jersey'},
    {name: 'NM', value: 'New Mexico'},
    {name: 'NY', value: 'New York'},
    {name: 'NC', value: 'North Carolina'},
    {name: 'ND', value: 'North Dakota'},
    {name: 'OH', value: 'Ohio'},
    {name: 'OK', value: 'Oklahoma'},
    {name: 'OR', value: 'Oregon'},
    {name: 'PA', value: 'Pennsylvania'},
    {name: 'PR', value: 'Puerto Rico'},
    {name: 'RI', value: 'Rhode Island'},
    {name: 'SC', value: 'South Carolina'},
    {name: 'SD', value: 'South Dakota'},
    {name: 'TN', value: 'Tennessee'},
    {name: 'TX', value: 'Texas'},
    {name: 'UT', value: 'Utah'},
    {name: 'VT', value: 'Vermont'},
    {name: 'VA', value: 'Virginia'},
    {name: 'VI', value: 'US Virgin Isles'},
    {name: 'WA', value: 'Washington'},
    {name: 'WV', value: 'West Virginia'},
    {name: 'WI', value: 'Wisconsin'},
    {name: 'WY', value: 'Wyoming'},
    {name: 'AP', value: 'Armed Forces Pacific'},
    {name: 'AE', value: 'Armed Forces Europe'},
    {name: 'AA', value: 'Armed Forces Americas'},
    {name: 'ZZ', value: 'Tax exempt'}
];

export enum KEY_CODE {
    SPACE = " ",
    PAGE_UP = "PageUp",
    PAGE_DOWN = "PageDown",
    LEFT_ARROW = "ArrowLeft",
    UP_ARROW = "ArrowUp",
    RIGHT_ARROW = "ArrowRight",
    DOWN_ARROW = "ArrowDown",
    DEL = "Delete",
    ESC = "Escape",
    B = "b",
    C = "c",
    D = "d",
    H = "h",
    HH = "H",
    L = "l",
    M = 'm',
    O = "o",
    OO = "O",
    S = "s",
    SS = "S",
    V = "v",
    W = "w",
    X = "x",
    Y = "y",
    Z = "z",
    P = "p",
    PP = "P",
    T = "t",
    TT = "T",
    PLUS = "=",
    MINUS = "-",
    BRACKET_LEFT = "[",
    BRACKET_RIGHT = "]",
    HELP = "/"
}

export const UserDataKeyMapping = {
    resources: {
        uniqueKey: 'id',
        tableName: 'resources',
        primaryKey: 'resource_id'
    },
    scenes: {
        uniqueKey: 'Player.$.id',
        tableName: 'player_data',
        primaryKey: 'player_data_id'
    },
    stations: {
        uniqueKey: 'station_id',
        tableName: 'branch_stations',
        primaryKey: 'branch_station_id'
    },
    catalogItemInfos: {
        uniqueKey: 'catalog_item_id',
        tableName: 'catalog_item_infos',
        primaryKey: 'catalog_item_id'
    },
    catalogItemResources: {
        uniqueKey: 'catalog_item_resource_id',
        tableName: 'catalog_item_resources',
        primaryKey: 'catalog_item_resource_id'
    },
    catalogItems: {
        uniqueKey: 'catalog_item_id',
        tableName: 'catalog_items',
        primaryKey: 'catalog_item_id'
    },
    categoryValues: {
        uniqueKey: 'category_values_id',
        tableName: 'category_values',
        primaryKey: 'category_value_id'
    },
    eventParams: {
        uniqueKey: 'event_param_id',
        tableName: 'event_params',
        primaryKey: 'event_param_id'
    },
    catalogItemCategories: {
        uniqueKey: 'catalog_item_category_id',
        tableName: 'catalog_item_categories',
        primaryKey: 'catalog_item_category_id'
    },
    transitionPools: {
        uniqueKey: 'id',
        tableName: 'transition_pools',
        primaryKey: 'transition_pool_id'
    },
    transitionPoolItems: {
        uniqueKey: 'transition_pool_item_id',
        tableName: 'transition_pool_items',
        primaryKey: 'transition_pool_item_id'
    },
    musicChannels: {
        uniqueKey: 'music_channel_id',
        tableName: 'music_channels',
        primaryKey: 'music_channel_id'
    },
    musicChannelSongs: {
        uniqueKey: 'music_channel_song_id',
        tableName: 'music_channel_songs',
        primaryKey: 'music_channel_song_id'
    },
    schedules: {
        uniqueKey: 'schedule_id',
        tableName: '',
        primaryKey: ''
    },
    scheduleEvents: {
        uniqueKey: 'schedule_event_id',
        tableName: '',
        primaryKey: ''
    },
    eventsStrings: {
        uniqueKey: '',
    },
    painters: {
        uniqueKey: 'id',
        tableName: 'painters',
        primaryKey: 'painter_id'
    },
};

